import { FeatureAppLoader } from '@feature-hub/react';
import { Breakpoints, CTA } from '@volkswagen-onehub/components-core';
import React, { useRef, useState } from 'react';
import { OfertasContext } from '../context/ofertas-context';
import {
	actionRedirect,
	getFinanciacionType,
	getPagoFinanciado,
	getPagoUnico,
} from '../helpers/ofertas-helper';
import { Oferta } from '../services/ofertas-service/models/ofertas';
import { useTrackingManager } from '../tracking/use-tracking-manager';

export const RedirectCTAs = ({
	oferta,
	copy,
	isMobile,
	emphasis,
	trackingRef,
	formTrigger,
}: {
	oferta: Oferta;
	copy: string;
	isMobile: boolean;
	emphasis: 'primary' | 'secondary';
	trackingRef?: string;
	formTrigger: string;
}) => {
	const { featureAppService, userInteractionService } =
		React.useContext(OfertasContext);
	const [showOneForm, setShowOneForm] = useState<boolean>(false);
	const featureAppRef = useRef(null);
	const trackingManager = useTrackingManager();

	const handleOnClick = () => {
		const pagoFinanciado = getPagoFinanciado(oferta.datosEconomicos);
		trackingManager.trackOfertasButtonClick(
			copy,
			{ contentId: trackingRef ? `${copy} - ${trackingRef}` : copy },
			{
				CarlineId: oferta.carline?.code.toString(),
				CarlineName: oferta.carline?.title,
				ModelId: oferta.configuracion.motorizacion.code?.split('-')[0],
				ModelName: oferta.carline?.salesgroup.model.name,
				ModelYear: oferta.carline?.salesgroup.year.toString(),
				SalesgroupName: oferta.carline?.salesgroup.title,
				PriceRateType: pagoFinanciado
					? getFinanciacionType(pagoFinanciado)
					: undefined,
				PriceRateTotal: pagoFinanciado?.precio ?? undefined,
				PriceRateCurrency: 'EUR',
				PriceTotalTotal:
					getPagoUnico(oferta.datosEconomicos)?.precio ?? undefined,
				PriceTotalCurrency: 'EUR',
			},
		);

		if (formTrigger === 'shorty') {
			actionRedirect(
				userInteractionService,
				`es-oneform-v2-action--open_layer?formName=lead-oferta&ofertaId=${oferta.id}`,
			);
		} else {
			setShowOneForm(true);
		}
	};

	const renderOneForm = (oferta: Oferta) => {
		if (showOneForm) {
			const featureApp =
				featureAppService.featureAppConfigurations[formTrigger];
			featureAppRef.current = featureApp;
		}

		return (
			<FeatureAppLoader
				{...featureAppRef.current}
				featureAppId={`${featureAppRef.current.name}:oneform`}
				done={() => setShowOneForm(false)}
				beforeCreate={(env) => {
					if (env.featureServices['fa-content-service']) {
						env.featureServices['fa-content-service'].content = {
							featureApp: 'es-ofertas',
							oferta: oferta,
						};
					}
					if (env.featureServices['api-key-provider']) {
						env.featureServices['api-key-provider'].apiKey =
							featureAppRef.current.apiKey;
					}
					if (env.featureServices.tracking) {
						env.featureServices.tracking.contextualEventData = {
							event: {
								environment: {
									featureAppId: featureAppRef.current.trackingId,
								},
							},
						};
					}
				}}
			/>
		);
	};

	return (
		<>
			<CTA
				data-testid="redirect-cta"
				tag="button"
				emphasis={emphasis}
				size={isMobile ? 'large' : 'small'}
				stretchContent={{
					[Breakpoints.default]: true,
					[Breakpoints.b560]: false,
				}}
				onClick={handleOnClick}
			>
				{copy}
			</CTA>
			{showOneForm ? renderOneForm(oferta) : null}
		</>
	);
};
